module.exports = __webpack_public_path__ + "img/SPMedical.cd9639a7.png";